<nav class="navbar navbar-expand-lg user-nav-mobile bottom-left-userbar">
  <div
    class="navbar-collapse d-lg-block toolbar-nav-wrapper collapse"
    id="navbarToolbar"
    [class.show]="smallScreen"
    [class.abp-collapsed-height]="smallScreen"
    [class.abp-mh-100]="smallScreen && isCollapseNavbarTool"
  >
    <ul class="navbar-nav toolbar-nav ms-auto">
      <li class="nav-item" *ngIf="currentUser$ | async as user">
        <ng-template #loginBtn>
          <a role="button" routerLink="/account/login" class="btn">{{
            'AbpAccount::Login' | abpLocalization
          }}</a>
        </ng-template>

        <div *ngIf="user.isAuthenticated; else loginBtn" class="dropdown btn-group" ngbDropdown>
          <a ngbDropdownToggle class="btn pointer userbar-btn">
            <span class="userbar-avatar" aria-hidden="true">
              <i class="fa-regular fa-user"></i>
            </span>

            <span class="userbar-text">
              <small *ngIf="(selectedTenant$ | async)?.name as tenantName" class="userbar-tenant"
                ><i [attr.title]="tenantName">{{ tenantName }}/</i></small
              >
              <span class="userbar-username" [attr.title]="user.userName">{{ user.userName }}</span>
            </span>

            <i class="fa-solid fa-angle-down userbar-angle" aria-hidden="true"></i>
          </a>

          <div ngbDropdownMenu class="dropdown-menu userbar-menu userbar-menu--fixed">
            <div class="p-2 row">
              <div class="pe-0 col col-auto">
                <span class="userbar-avatar userbar-avatar--lg" aria-hidden="true">
                  <i class="fa-regular fa-user"></i>
                </span>
              </div>
              <div class="ps-2 col">
                <span>{{ 'AbpAccount::Welcome' | abpLocalization }}</span><br />
                <small *ngIf="(selectedTenant$ | async)?.name as tenantName"
                  ><i>{{ tenantName }}</i>\</small
                >
                <strong>{{ user.userName }}</strong>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <a class="dropdown-item pointer" (click)="onClickManageProfile()">{{
              'AbpAccount::MyAccount' | abpLocalization
            }}</a>
            <a class="dropdown-item pointer" routerLink="/account/security-logs">{{
              'AbpAccount::MySecurityLogs' | abpLocalization
            }}</a>
            <a class="dropdown-item pointer" (click)="openVersionModal(versionInfoModal)">{{
              '::About' | abpLocalization
            }}</a>
            <a class="dropdown-item pointer" (click)="clearFilterCache()">{{
              '::ClearCache' | abpLocalization
            }}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item pointer" id="logout" (click)="logout()">{{
              'AbpUi::Logout' | abpLocalization
            }}</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>

<ng-template #versionInfoModal let-modal>
  <div class="modal-body">
    <app-version-info></app-version-info>
  </div>
  <div class="modal-footer">
    <app-custom-button variant="outline" size="md" (btnClick)="modal.dismiss()">
      {{ 'AbpUi::Close' | abpLocalization }}
    </app-custom-button>
  </div>
</ng-template>
